import React, { useEffect, useState } from 'react';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from '@mui/material';
import clsx from 'clsx';
import { useParams } from 'react-router-dom';
import { apiClient } from 'shared/api';
import { useUser } from 'shared/api/tanstack';
import { ButtonCustom } from 'shared/ui/button-custom';
import { DownloadButton } from 'shared/ui/download-button';
import styles from './offer.module.scss';

export const Offer = () => {
  const { type, uid, oid } = useParams();

  const { data: user } = useUser();

  const [dynamicField, setDynamicField] = useState<any>([]);
  const [appData, setAppData] = useState<any>([]);
  const [offerData, setOfferData] = useState<any>([]);

  const postDataApp = async () => {
    try {
      if (type == 'select') {
        const data = { id: uid };
        const responseApp = await apiClient.post('/select-applications/app-full', data);
        setAppData(responseApp?.data?.data?.application);
      } else {
        const data = { id: uid };
        const responseApp = await apiClient.post('/leasing-applications/app-full', data);
        setAppData(responseApp?.data?.data?.application);
      }
    } catch (error) {
      console.error('Ошибка при отправке данных:', error);
    }
  };

  const postDataOffer = async () => {
    try {
      if (type == 'select') {
        const data = { id: oid };
        const responseApp = await apiClient.post('/select-offers/app-offer-full', data);
        setOfferData(responseApp?.data?.data?.offer);
      } else {
        const data = { id: oid };
        const responseApp = await apiClient.post('/leasing-offers/app-offer-full', data);
        setOfferData(responseApp?.data?.data?.offer);
      }
    } catch (error) {
      console.error('Ошибка при отправке данных:', error);
    }
  };

  useEffect(() => {
    postDataOffer();
  }, []);

  useEffect(() => {
    if (offerData?.leasing_application?.documentId || offerData?.select_application?.documentId) {
      postDataApp();
    }
  }, [offerData]);

  useEffect(() => {
    setDynamicField(appData?.car_params || []);
  }, [appData]);

  const isStock = (status: string) => {
    return status == 'В наличии';
  };
  const isOrder = (status: string) => {
    return status == 'Под заказ';
  };
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const handleAcceptModal = () => {
    setOpen(true);
  };
  const handleAccept = async () => {
    const data = { id: oid };
    const url =
      type == 'select' ? '/select-offers/acceptEmployer' : '/leasing-offers/acceptEmployer';
    const responseOffer = await apiClient.post(url, data);
    postDataOffer();
    setOpen(false);
  };

  async function handleConfirm() {
    try {
      const data = { id: offerData?.custom_uid };
      const url = type == 'select' ? '/select-offers/complete' : '/leasing-offers/complete';
      const responseOffer = await apiClient.post(url, data);
      postDataApp();
    } catch (error) {
      console.error('Ошибка при отправке данных:', error);
    }
  }

  async function handleCancel() {
    try {
      const data = { id: offerData?.custom_uid };
      const url = type == 'select' ? '/select-offers/cancel' : '/leasing-offers/cancel';
      const responseOffer = await apiClient.post(url, data);
      postDataApp();
    } catch (error) {
      console.error('Ошибка при отправке данных:', error);
    }
  }

  const acceptCondition =
    offerData?.status_accept && offerData?.status_filled && offerData?.status_admin_approve;

  const renderApp = () => {
    if (type == 'select') {
      return (
        <Box className={styles.appWrapper}>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Статус заявки</span>
            <span className={styles.appDescValue}>{appData?.fulfilled === false ? 'Черновик' : appData?.status_app}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Состояние</span>
            <span className={styles.appDescValue}>{appData?.condition}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Cпособ покупки</span>
            <span className={styles.appDescValue}>{appData?.pay_method}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Количество ТС</span>
            <span className={styles.appDescValue}>{appData?.quantity}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Траснспортное средство</span>
            <span className={styles.appDescValue}>
              {appData?.car_type ? `${appData?.car_type} - ` : ''}{' '}
              {appData?.car_subtype ? appData?.car_subtype : ''}
            </span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Марка</span>
            <span className={styles.appDescValue}>{appData?.car_brand}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Модель</span>
            <span className={styles.appDescValue}>{appData?.vehicle}</span>
          </Box>

          {dynamicField?.map((field: any) => (
            <Box key={field?.fieldName} className={styles.appDesc}>
              <span className={styles.appDescTitle}>{field?.fieldName}</span>
              <span className={styles.appDescValue}>{field?.fieldValue}</span>
            </Box>
          ))}

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Бюджет на покупку</span>
            <span className={styles.appDescValue}>
              {new Intl.NumberFormat('ru-RU').format(appData?.budget as number)} ₽
            </span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>ИНН</span>
            <span className={styles.appDescValue}>
              {offerData?.status_employer_approve ? appData?.inn : '********'}
            </span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Телефон</span>
            <span className={styles.appDescValue}>
              {offerData?.status_employer_approve ? appData?.phone : '********'}
            </span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>E-mail</span>
            <span className={styles.appDescValue}>
              {offerData?.status_employer_approve ? appData?.email : '********'}
            </span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>ФИО</span>
            <span className={styles.appDescValue}>
              {offerData?.status_employer_approve ? appData?.bio : '********'}
            </span>
          </Box>

          {appData?.kp && (
            <Box className={styles.appDesc}>
              <span className={styles.appDescTitle}>Имеющееся предложение</span>
              <DownloadButton fileUrl={appData?.kp?.url} title={appData?.kp?.name} />
            </Box>
          )}
        </Box>
      );
    }
    if (type == 'leasing') {
      return (
        <Box className={styles.appWrapper}>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Статус заявки</span>
            <span className={styles.appDescValue}>{appData?.fulfilled === false ? 'Черновик' : appData?.status_app}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Траснспортное средство</span>
            <span className={styles.appDescValue}>
              {appData?.car_type ? `${appData?.car_type} - ` : ''}{' '}
              {appData?.car_subtype ? appData?.car_subtype : ''}
            </span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Марка</span>
            <span className={styles.appDescValue}>{appData?.car_brand}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Модель</span>
            <span className={styles.appDescValue}>{appData?.vehicle}</span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Количество ТС</span>
            <span className={styles.appDescValue}>{appData?.quantity}</span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Стоимость предмета лизинга</span>
            <span className={styles.appDescValue}>
              {new Intl.NumberFormat('ru-RU').format(appData?.price as number)} ₽
            </span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Первоначальный взнос</span>
            <span className={styles.appDescValue}>{appData?.initial_payment} %</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Срок лизинга</span>
            <span className={styles.appDescValue}>{appData?.lease_period} мес.</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Тип оплаты</span>
            <span className={styles.appDescValue}>{appData?.payment_type}</span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>ИНН</span>
            <span className={styles.appDescValue}>
              {offerData?.status_employer_approve ? appData?.inn : '********'}
            </span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Телефон</span>
            <span className={styles.appDescValue}>
              {offerData?.status_employer_approve ? appData?.phone : '********'}
            </span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>E-mail</span>
            <span className={styles.appDescValue}>
              {offerData?.status_employer_approve ? appData?.email : '********'}
            </span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>ФИО</span>
            <span className={styles.appDescValue}>
              {offerData?.status_employer_approve ? appData?.bio : '********'}
            </span>
          </Box>

          {appData?.kp && (
            <Box className={styles.appDesc}>
              <span className={styles.appDescTitle}>Имеющееся предложение</span>
              <DownloadButton fileUrl={appData?.kp?.url} title={appData?.kp?.name} />
            </Box>
          )}
        </Box>
      );
    }
  };

  const renderOffer = () => {
    if (type == 'select') {
      return (
        <Box key={offerData.id} className={styles.offerBlock}>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Состояние</span>
            <span className={styles.appDescValue}>{offerData?.condition}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Количество ТС</span>
            <span className={styles.appDescValue}>{offerData?.quantity}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Траснспортное средство</span>
            <span className={styles.appDescValue}>
              {offerData?.car_type} - {offerData?.car_subtype}
            </span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Марка</span>
            <span className={styles.appDescValue}>{offerData?.car_brand}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Модель</span>
            <span className={styles.appDescValue}>{offerData?.vehicle}</span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Стоимость</span>
            <span className={styles.appDescValue}>
              {new Intl.NumberFormat('ru-RU').format(offerData?.price as number)} ₽
            </span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Наличие</span>
            <span
              className={clsx([
                `${styles.appDescValue}`,
                isStock(offerData?.availability) && `${styles.stock}`,
                isOrder(offerData?.availability) && `${styles.order}`,
              ])}
            >
              {offerData?.availability}
            </span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Срок поставки</span>
            <span className={styles.appDescValue}>{offerData?.delivery_time}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Город</span>
            <span className={styles.appDescValue}>{offerData?.city}</span>
          </Box>

          {offerData?.kp && (
            <Box className={styles.appDesc}>
              <span className={styles.appDescTitle}>Коммерческое предложение</span>
              <DownloadButton fileUrl={offerData?.kp?.url} title={offerData?.kp?.name} />
            </Box>
          )}

          {acceptCondition && !offerData?.status_employer_approve && (
            <Box className={styles.acceptBtn}>
              <ButtonCustom onClick={handleAcceptModal}>Принять в работу</ButtonCustom>
            </Box>
          )}
          {offerData?.status_employer_approve &&
            appData?.status_app !== 'Отменена' &&
            appData?.status_app !== 'Выполнена' &&
            appData?.status_app !== 'Закрыта' && (
              <>
                {['agent', 'client'].includes(user?.user_type) && (
                  <Box className={styles.cancelButton}>
                    <ButtonCustom className={styles.canceledBtn} onClick={handleCancel}>
                      Отказ
                    </ButtonCustom>
                  </Box>
                )}
                <Box className={styles.acceptBtn}>
                  <ButtonCustom className={styles.completedBtn} onClick={handleConfirm}>
                    Закрыть сделку
                  </ButtonCustom>
                </Box>
              </>
            )}
        </Box>
      );
    }
    if (type == 'leasing') {
      return (
        <Box key={offerData.id} className={styles.offerBlock}>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Траснспортное средство</span>
            <span className={styles.appDescValue}>
              {offerData?.car_type} - {offerData?.car_subtype}
            </span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Марка</span>
            <span className={styles.appDescValue}>{offerData?.car_brand}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Модель</span>
            <span className={styles.appDescValue}>{offerData?.vehicle}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Количество ТС</span>
            <span className={styles.appDescValue}>{offerData?.quantity}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Стоимость</span>
            <span className={styles.appDescValue}>
              {new Intl.NumberFormat('ru-RU').format(offerData?.price as number)} ₽
            </span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Первоначальный взнос</span>
            <span className={styles.appDescValue}>{offerData?.initial_payment} %</span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Срок лизинга</span>
            <span className={styles.appDescValue}>{offerData?.lease_period} мес.</span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Общая сумма лизинговых платежей</span>
            <span className={styles.appDescValue}>
              {new Intl.NumberFormat('ru-RU').format(offerData?.sum_total as number)} ₽
            </span>
          </Box>
          {offerData?.month_pay && (
            <Box className={styles.appDesc}>
              <span className={styles.appDescTitle}>Размер ежемесячного платежа</span>
              <span className={styles.appDescValue}>
                {new Intl.NumberFormat('ru-RU').format(offerData?.month_pay as number)} ₽
              </span>
            </Box>
          )}

          {/* <Box className={styles.appDesc}>*/}
          {/*  <span className={styles.appDescTitle}>Разница</span>*/}
          {/*  <span className={styles.appDescValue}>{new Intl.NumberFormat('ru-RU').format((offerData?.sum_diff) as number)} ₽</span>*/}
          {/* </Box>*/}
          {/* <Box className={styles.appDesc}>*/}
          {/*  <span className={styles.appDescTitle}>Удорожание</span>*/}
          {/*  <span className={styles.appDescValue}>{offerData?.rise_price} %</span>*/}
          {/* </Box>*/}
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Город</span>
            <span className={styles.appDescValue}>{offerData?.city}</span>
          </Box>

          {offerData?.calc && (
            <Box className={styles.appDesc}>
              <span className={styles.appDescTitle}>Расчет по форме</span>
              <DownloadButton fileUrl={offerData?.calc?.url} title={offerData?.calc?.name} />
            </Box>
          )}

          {offerData?.kp && (
            <Box className={styles.appDesc}>
              <span className={styles.appDescTitle}>Коммерческое предложение</span>
              <DownloadButton fileUrl={offerData?.kp?.url} title={offerData?.kp?.name} />
            </Box>
          )}
          {acceptCondition && !offerData?.status_employer_approve && (
            <Box className={styles.acceptBtn}>
              <ButtonCustom onClick={handleAcceptModal}>Принять в работу</ButtonCustom>
            </Box>
          )}
          {offerData?.status_employer_approve &&
            appData?.status_app !== 'Отменена' &&
            appData?.status_app !== 'Выполнена' &&
            appData?.status_app !== 'Закрыта' && (
              <>
                {['agent', 'client'].includes(user?.user_type) && (
                  <Box className={styles.cancelButton}>
                    <ButtonCustom className={styles.canceledBtn} onClick={handleCancel}>
                      Отказ
                    </ButtonCustom>
                  </Box>
                )}
                <Box className={styles.acceptBtn}>
                  <ButtonCustom className={styles.completedBtn} onClick={handleConfirm}>
                    Закрыть сделку
                  </ButtonCustom>
                </Box>
              </>
            )}
        </Box>
      );
    }
  };

  return (
    <Box className={styles.offerWrapper}>
      <Box className={styles.offerInside}>
        <span className={styles.header}>Заявка № {appData.id}</span>
        {renderApp()}
      </Box>

      <Box className={styles.offerInside}>
        <span className={styles.header}>Форма заполнения</span>
        {renderOffer()}
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        sx={{
          '.MuiDialog-paper': {
            padding: '20px',
            borderRadius: '10px',
            maxWidth: '386px',
          },
        }}
      >
        <DialogTitle className={styles.modalTitle} id='alert-dialog-title'>
          <span>Подтвердить принятие заявки в работу</span>
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={styles.modalDescription} id='alert-dialog-description'>
            <span>
              Нажимая на кнопку «Да, согласен», <br />
              вы подтверждаете принятие заявки <br />в работу согласно{' '}
              <a target='_blank' href='/Договор.pdf'>
                заключенному договору
              </a>{' '}
              с компанией TLS-Group.
            </span>
          </DialogContentText>
        </DialogContent>
        <DialogActions className={styles.modalButtonWrapper}>
          <ButtonCustom className={styles.modalButtonCancel} onClick={handleClose}>
            Отмена
          </ButtonCustom>
          <ButtonCustom className={styles.modalButton} onClick={handleAccept}>
            Да, согласен
          </ButtonCustom>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
